import * as React from 'react'

import { Check } from 'lucide-react'
import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import Localization from '~/client/src/shared/localization/LocalizationManager'

import WorkflowTypesStore from '../../stores/domain/WorkflowTypes.store'
import EventsStore from '../../stores/EventStore/Events.store'
import CommonStore from '../../stores/ui/Common.store'
import { Content, Footer, Header, View } from '../Layout'
import { Loader } from '../Loader'
import { Button } from '../shadcn-ui/button'
import WorkflowTypeIcon from '../WorkflowTypeIcon/WorkflowTypeIcon'
import WorkflowTypeSelectorStore from './WorkflowTypeSelector.store'

import './WorkflowTypeSelector.scss'

// localization: translated

interface IProps {
  eventsStore?: EventsStore
  workflowTypesStore?: WorkflowTypesStore
  common?: CommonStore
}

@inject('eventsStore', 'workflowTypesStore', 'common')
@observer
export default class WorkflowTypeSelector extends React.Component<IProps> {
  private readonly store: WorkflowTypeSelectorStore = null

  public constructor(props: IProps) {
    super(props)

    this.store = new WorkflowTypeSelectorStore(
      props.eventsStore,
      props.workflowTypesStore,
      props.common,
    )
  }

  public render() {
    if (this.store.isLoading) {
      return <Loader />
    }

    const {
      workflowTypes,
      applySelection,
      selectWorkflowType,
      selectedWorkflowTypeId,
    } = this.store

    return (
      <View className="permit-type-selector-container">
        <Header>
          <div className="text header center bold py30">
            {Localization.translator.selectWorkForm}
          </div>
        </Header>
        <Content scrollable={true}>
          {workflowTypes.map((workflowType, index) => {
            const { id, name } = workflowType

            return (
              <div
                key={id}
                className={classList({
                  'row pa24 bb-light-input-border pointer': true,
                  'bt-light-input-border': index === 0,
                  'active-type': selectedWorkflowTypeId === id,
                })}
                onClick={selectWorkflowType.bind(null, id)}
              >
                <WorkflowTypeIcon
                  iconName={workflowType?.iconName}
                  className="type-icon row mr12 no-grow"
                />

                <span className="text extra-large">{name}</span>
                {id === selectedWorkflowTypeId && (
                  <Check size={16} className="no-grow" />
                )}
              </div>
            )
          })}
        </Content>
        <Footer className="pa10">
          <div className="col">
            <Button
              onClick={applySelection}
              disabled={!selectedWorkflowTypeId}
              variant="default"
              className="py20"
            >
              {Localization.translator.select}
            </Button>
          </div>
        </Footer>
      </View>
    )
  }
}
